import { ADMIN_ROUTES } from '@constants'
import { Box, Grid } from '@mui/material'
import { AppFilterPanel, filterPanelGridSx } from '@components'
import PageWrapper from 'Pages/@PageWrapper'
import { resetSignals } from 'Pages/Admin/GroupedExports/@signals'
import DateRangeFilter from 'Pages/Admin/GroupedExports/Filter'
import GroupedExportsModal from 'Pages/Admin/GroupedExports/Modal'
import GroupedExportsTable from 'Pages/Admin/GroupedExports/Table'
import React, { useEffect } from 'react'


export default function GroupedExportsPage({ isExtra = false }) {

	useEffect(() => {
		resetSignals()
		return () => resetSignals()
	}, [ isExtra ])

	return <PageWrapper
		head={`DS Rentacar | ${ADMIN_ROUTES.TITLE}`}
		title={ADMIN_ROUTES.TITLE}
		subtitle={isExtra ? ADMIN_ROUTES.GROUPED_EXTRA_EXPORTS_SUBTITLE : ADMIN_ROUTES.GROUPED_EXPORTS_SUBTITLE}
		isEmpty={false}
	>
		<AppFilterPanel>
			<Box sx={filterPanelGridSx(4)}>
				<DateRangeFilter/>
			</Box>
		</AppFilterPanel>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<GroupedExportsTable isExtra={isExtra}/>
			</Grid>
			<Grid item xs={12}>
				<GroupedExportsModal/>
			</Grid>
		</Grid>
	</PageWrapper>
}